import { ValueGetterParams } from 'ag-grid-enterprise';
import { take } from 'rxjs/operators';
import { DocumentReader } from 'src/app/modules/core/store/models';

export const multiPicklistValueGetter = (params: ValueGetterParams) => {
  const field = params.colDef.cellRendererParams.schemaField;
  const picklistService = params.colDef.cellRendererParams.picklistService;

  const reader = new DocumentReader(params.data);
  const selectedItems = reader.getFieldValue(field.systemName);

  let value = '';
  if (!!selectedItems) {
    if (!!picklistService) {
      picklistService
        .getPicklistValues(field)
        .pipe(take(1))
        .subscribe(picklistValues => {
          selectedItems.map(val => {
            const selectedPicklistItem = picklistValues?.find(pv => pv.uId === val);
            if (!!selectedPicklistItem) {
              value += value.length > 0 ? `, ${selectedPicklistItem.value}` : selectedPicklistItem.value;
            }
          });
        });
    } else {
      selectedItems.map(val => {
        const selectedPicklistItem = field.picklistValues?.find(pv => pv.uId === val);
        if (!!selectedPicklistItem) {
          value += value.length > 0 ? `, ${selectedPicklistItem.value}` : selectedPicklistItem.value;
        }
      });
    }
  }

  return value;
};
